import { render } from "./Index.vue?vue&type=template&id=b32aca14&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=b32aca14&lang=stylus"
import "./Index.vue?vue&type=style&index=1&id=b32aca14&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32aca14"]])

export default __exports__